import cx from 'classnames';
import React from 'react';
import { FormInputChoice, useId } from '../index.js';
import { toValue } from '../listbox/index.js';
export const FormInputChoiceGroup = ({ children, className, layout, name, onChange, onOptionSelect, options, selected, type, ...rest }) => {
    const id = useId();
    const htmlName = name || id;
    if (!children && (!options || !options.length)) {
        return null;
    }
    const htmlType = type || (Array.isArray(selected) ? 'checkbox' : 'radio');
    const handleChange = (e, option) => {
        if (onChange)
            onChange(e);
        if (onOptionSelect)
            onOptionSelect(e.target.value, option);
    };
    return (React.createElement("div", { className: cx('tds-form-input-group', {
            [`tds-form-input-group--layout-${layout}`]: layout,
        }, className), ...rest }, children ||
        (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - TODO: option doens't 100% align to choice props - AWSM-5612
        options === null || options === void 0 ? void 0 : options.map((option) => {
            const value = toValue(option);
            return (React.createElement(FormInputChoice, { checked: selected !== undefined
                    ? Array.isArray(selected)
                        ? selected.includes(value)
                        : selected === value
                    : undefined, key: value, name: htmlName, onChange: (e) => handleChange(e, option), type: htmlType, ...option, value: value }));
        }))));
};
